import ArticleInfo from '@/components/BlogComponents/shared/ArticleInfo/ArticleInfo';
import BlogTag from '@/components/BlogComponents/shared/BlogTag/BlogTag';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import Link from '@/components/Link/Link';
import type { BlogPageType } from '@/contentful/api/api.types';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/theme/values/brandColors';

import useStyles from './ArticleHeroImage.styles';

export default function ArticleHeroImage({
  article,
  isHero,
}: {
  article: BlogPageType;
  isHero?: boolean;
}) {
  const {
    heroImage,
    blogTitle,
    category,
    readTimeMinutes,
    path,
    categoryPath,
  } = article;

  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <Link
      className={classes.featuredArticleContainer}
      href={path}
      title={blogTitle}
    >
      {heroImage?.[0] && (
        <ResponsiveImage
          src={heroImage[0]}
          decorative
          sizes={{ xs: 640, sm: 944, md: 1312, lg: 1280 }}
          priority={isHero}
        />
      )}
      <div className={classes.gradientWrapper}>
        <div
          className={classes.featuredArticleTextContainer}
          data-testid='featuredArticle'
        >
          <div className={classes.titleContainer}>
            <h3 className={cx(globalClasses.h3, classes.heading)}>
              {blogTitle}
            </h3>
          </div>

          <ArticleInfo
            classname={classes.articleInfo}
            textColor={brandColors.white}
            readingTime={readTimeMinutes}
          />
          {category && categoryPath && (
            <BlogTag category={category} path={categoryPath} renderAsDiv />
          )}
        </div>
      </div>
    </Link>
  );
}
